module.exports = class a extends require('base/infoline') { };
